module.exports = __webpack_public_path__ + "media/Video 35.db25607b.mp4";